module["exports"] = [
  "#{street_name} #{building_number}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/address/street_address.js
// module id = 1739
// module chunks = 1